// extracted by mini-css-extract-plugin
module.exports = {"container":"BankSlip_container_3ljk5","add":"BankSlip_add_33Kxp","row":"BankSlip_row_4qjLT","scan-field":"BankSlip_scan-field_2KcMA","scanField":"BankSlip_scan-field_2KcMA"};